module.exports = __webpack_public_path__ + "static/media/CHANGELOG.714f8df5.md";